import { LimeModal } from "@/Components/NextBase/LimeModal";
import type {
  AnnouncementButton,
  GetClientActiveAnnouncement,
  RenderedAnnouncementContent,
} from "@/server-types";
import { ModalBody, ModalContent, type ModalProps } from "@heroui/react";
import { AnnouncementContent } from "./AnnouncementContent";

export type AnnouncementSize = NonNullable<
  GetClientActiveAnnouncement["response"]["announcement"]
>["size"];

const MODAL_SIZES: Record<AnnouncementSize, ModalProps["size"]> = {
  small: "sm",
  medium: "md",
  large: "lg",
  extraLarge: "xl",
};

export function AnnouncementDialog({
  isOpen,
  onClose,
  size,
  content,
  onButtonPress,
  onDashboardLink,
  dataIdentifier,
}: {
  isOpen: boolean;
  onClose: () => void;
  size: AnnouncementSize;
  content: RenderedAnnouncementContent;
  onButtonPress: (button: AnnouncementButton) => void;
  onDashboardLink: (path: string) => void;
  dataIdentifier: string;
}) {
  return (
    <LimeModal
      isOpen={isOpen}
      onClose={onClose}
      placement="center"
      size={MODAL_SIZES[size]}
      // LimeModal defaults to "outside", which pins the dialog to the top.
      scrollBehavior="inside"
      data-identifier={dataIdentifier}
    >
      <ModalContent>
        <ModalBody className="py-8">
          <AnnouncementContent
            content={content}
            onButtonPress={onButtonPress}
            onDashboardLink={onDashboardLink}
          />
        </ModalBody>
      </ModalContent>
    </LimeModal>
  );
}
